import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgType?: string;
  $bgColor?: string;
}

const getBgColor = ($bgType?: string) => {
  if ($bgType === 'black') return '#252525';
  if ($bgType === 'opacity') return 'rgba(172, 172, 172, 0.15)';
  return '#F6F6F6';
};

const getCircleColor = ($bgType?: string, $bgColor?: string) => {
  if ($bgType === 'black') return '#000';
  if ($bgType === 'opacity') return $bgColor ?? 'transparent';
  return '#fff';
};

const getSkeletonColor = ($bgType?: string) => {
  if ($bgType === 'black') return '#333';
  if ($bgType === 'opacity') return 'rgba(172, 172, 172, 0.15)';
  return '#eee';
};

export const Box = styled.div<IProps>`
  position: relative;
  width: 100%;
  height: 60px;
  background: ${({ $bgType }) => getBgColor($bgType)};

  &:before,
  &:after {
    position: absolute;
    right: 48px;
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: ${({ $bgType, $bgColor }) => getCircleColor($bgType, $bgColor)};
    z-index: 2;
  }

  &:before {
    top: -4.5px;
  }

  &:after {
    bottom: -4.5px;
  }

  .skeleton-wrap {
    ${mixin.flex({ justify: 'space-between', align: 'center' })};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 15px 0 20px;
  }

  .skeleton {
    border-radius: 4px;
    background: ${({ $bgType }) => getSkeletonColor($bgType)};
  }

  .text-wrap {
    .title {
      width: 240px;
      height: 19px;
      margin-bottom: 2px;
    }

    .desc {
      width: 86px;
      height: 14px;
    }
  }

  .icon {
    width: 20px;
    height: 20px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('60')};

    &:before,
    &:after {
      right: ${mixin.pxToVw('48')};
      width: ${mixin.pxToVw('9')};
      height: ${mixin.pxToVw('9')};
    }

    &:before {
      top: ${mixin.pxToVw('-4.5')};
    }

    &:after {
      bottom: ${mixin.pxToVw('-4.5')};
    }

    .skeleton {
      border-radius: ${mixin.pxToVw('4')};
    }

    .skeleton-wrap {
      padding: 0 ${mixin.pxToVw('15')} 0 ${mixin.pxToVw('20')};
    }

    .text-wrap {
      .title {
        width: ${mixin.pxToVw('240')};
        height: ${mixin.pxToVw('19')};
        margin-bottom: ${mixin.pxToVw('2')};
      }

      .desc {
        width: ${mixin.pxToVw('86')};
        height: ${mixin.pxToVw('14')};
      }
    }

    .icon {
      width: ${mixin.pxToVw('20')};
      height: ${mixin.pxToVw('20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 430px;
    height: 84px;

    &:before,
    &:after {
      right: 75.5px;
      width: 9px;
      height: 9px;
    }

    &:before {
      top: -4.5px;
    }

    &:after {
      bottom: -4.5px;
    }

    .skeleton-wrap {
      padding: 0 24px;
    }

    .text-wrap {
      .title {
        width: 279px;
        height: 21px;
        margin-bottom: 8px;
      }

      .desc {
        width: 111px;
        height: 17px;
      }
    }

    .icon {
      width: 32px;
      height: 32px;
    }
  }
`;
